import axios from './axios';
import config from '../../helpers/config';

export default function setDesignAttribute(designId, data) {
  const url = `${config.designBuilderApiBaseUrl}/designs/${designId}/set-attribute`;

  return axios.post(url, data);
}
